var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.16)",
    fill: "none",
    stroke: "#e52431",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.5,
    cy: 30,
    rx: 29.5,
    ry: 30,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.5,
    cy: 30,
    rx: 28,
    ry: 28.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.64,17.2l-5.323-2.281a1.141,1.141,0,0,0-1.331.328l-2.357,2.88A17.617,17.617,0,0,1,6.207,9.7l2.88-2.357a1.138,1.138,0,0,0,.328-1.331L7.134.69A1.148,1.148,0,0,0,5.827.029L.884,1.17A1.141,1.141,0,0,0,0,2.281,22.051,22.051,0,0,0,22.053,24.335a1.141,1.141,0,0,0,1.112-.884l1.141-4.943A1.154,1.154,0,0,0,23.64,17.2Z",
    transform: "translate(17.575 17.574)",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.65931cb075a3cc5485b49f438a3da3aa.svg";
export { ForwardRef as ReactComponent };